import React from "react";
import { DatePicker } from "antd";
import PropTypes from "prop-types";
import "./style.scss"; // Add custom styles if needed

const { RangePicker } = DatePicker;

const PRZDatePicker = ({
  value,
  onChange,
  placeholder,
  picker,
  format = "YYYY-MM-DD",
  allowClear = true,
  size = "middle",
  disabled,
  disabledDate,
  showTime = false,
  mode,
  className,
  wrapperClassName,
  showToday = true,
  type = "single", // "single" or "range"
  wrapperStyle,
  popupStyle,
  endOfDay,
  startOfDay,
  ...rest
}) => {
  return (
    <div
      className={`prz-datepicker__wrapper ${wrapperClassName}`}
      style={wrapperStyle}
    >
      {type === "single" ? (
        <DatePicker
          value={value}
          onChange={(date) => {
            if (date) {
              if (startOfDay) {
                const adjustedDate = date.startOf("day"); // Set to 12:00 AM
                onChange(adjustedDate);
              } else if(endOfDay) {
                const adjustedDate = date.endOf("day"); // Set to 11:59 PM
                onChange(adjustedDate);
              } else {
                onChange(date); // Set to current time
              }
            }
          }}
          placeholder={placeholder}
          picker={picker}
          format={format}
          allowClear={allowClear}
          size={size}
          disabled={disabled}
          disabledDate={disabledDate}
          showTime={showTime}
          showToday={showToday}
          className={`${className} prz-custom-datepicker`}
          popupStyle={popupStyle}
          {...rest}
        />
      ) : (
        <RangePicker
          value={value}
          onChange={(date) => {
            if (date && date.length === 2) {
              const [start, end] = date;
              const adjustedStart = start.startOf("day"); // Set to 12:00 AM
              const adjustedEnd = end.endOf("day"); // Set to 11:59 PM
              onChange([adjustedStart, adjustedEnd]);
            }
          }}
          placeholder={["Start date", "End date"]}
          picker={picker}
          format={format}
          allowClear={allowClear}
          size={size}
          disabled={disabled}
          disabledDate={disabledDate}
          showTime={showTime}
          className={`${className} prz-custom-rangepicker`}
          popupStyle={popupStyle}
          {...rest}
        />
      )}
    </div>
  );
};

// PropTypes for validation
PRZDatePicker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object, // For moment object in single picker
    PropTypes.array, // For array of moment objects in range picker
  ]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string), // For range picker placeholders
  ]),
  picker: PropTypes.oneOf(["date", "week", "month", "quarter", "year"]),
  format: PropTypes.oneOf([
    "YYYY-MM-DD",
    "DD/MM/YYYY",
    "MM-DD-YYYY",
    "ddd, MMM D, YYYY",
    "YYYY/MM/DD HH:mm",
  ]),
  allowClear: PropTypes.bool,
  size: PropTypes.oneOf(["small", "middle", "large"]),
  disabled: PropTypes.bool,
  disabledDate: PropTypes.func,
  showTime: PropTypes.bool,
  showToday: PropTypes.bool,
  mode: PropTypes.oneOf(["time", "date", "month", "year", "decade"]),
  type: PropTypes.oneOf(["single", "range"]), // Determines whether single or range picker
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

// Default Props
PRZDatePicker.defaultProps = {
  placeholder: "Select a date",
  picker: "date",
  format: "YYYY-MM-DD",
  allowClear: true,
  size: "middle",
  disabled: false,
  showTime: false,
  showToday: true,
  type: "single",
  className: "",
  wrapperClassName: "",
};

export default PRZDatePicker;
